import React from 'react';
import { motion } from 'framer-motion';
import './Certifications.css';

const certifications = [
  {
    title: 'CS50P: Introduction to Programming with Python',
    image: '/CS50P.png',
    issuer: 'Harvard University',
    description:
      '40+ problem sets covering Python fundamentals, data structures, and practical programming.',
  },
  {
    title: 'Responsive Web Design',
    image: '/certification1.png',
    issuer: 'freeCodeCamp',
    description:
      'Modern HTML/CSS, responsive layouts, and accessible web design patterns.',
  },
  {
    title: 'JavaScript Algorithms and Data Structures',
    image: '/certification2.png',
    issuer: 'freeCodeCamp',
    description:
      'ES6+, algorithms, and core data structures for writing reliable JavaScript.',
  },
  {
    title: 'Scientific Computing with Python',
    image: '/certification3.png',
    issuer: 'freeCodeCamp',
    description:
      'Python for computation and analysis — scripting, data handling, and problem solving.',
  },
];

const Certifications = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
      },
    },
  };

  return (
    <div className="certifications-section" id="certifications">
      <div className="certifications-container">
        <motion.div
          className="certifications-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.2, once: false }}
        >
          <motion.h2 className="certifications-title" variants={itemVariants}>
            Certifications
          </motion.h2>

          <motion.div className="certifications-grid" variants={itemVariants}>
            {certifications.map((cert) => (
              <motion.div
                key={cert.title}
                className="certification-card"
                whileHover={{ scale: 1.02, y: -5 }}
                transition={{ duration: 0.3 }}
              >
                <div className="certification-image-container">
                  <img
                    src={cert.image}
                    alt={cert.title}
                    className="certification-image"
                  />
                </div>
                <div className="certification-info">
                  <p className="certification-issuer">{cert.issuer}</p>
                  <h3 className="certification-title">{cert.title}</h3>
                  <p className="certification-description">{cert.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Certifications;
